import { render, staticRenderFns } from "./gCell.vue?vue&type=template&id=89d2bf20&scoped=true&"
import script from "./gCell.vue?vue&type=script&lang=js&"
export * from "./gCell.vue?vue&type=script&lang=js&"
import style0 from "./gCell.vue?vue&type=style&index=0&id=89d2bf20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d2bf20",
  null
  
)

export default component.exports